import { createReducer } from "@reduxjs/toolkit";


const initialState ={
    cartItems: [],
    subtotal: 0,
    shipping: 0,
    tax: 0,
    total: 0,
};

export const cartReducer=createReducer(initialState ,(builder)=>{
    builder
            .addCase('addToCart', (state, action) => {
                const item = action.payload;
                const isItemExist = state.cartItems.find((i) => i.id === item.id);

                if (isItemExist) {
                    state.cartItems.forEach((i) => {
                        if(i.id === item.id) i.quantity += 1;
                    });
                } else {
                    state.cartItems.push({ ...item, quantity: 1 });
                }
            })
            .addCase('decrement',(state,action)=>{
                const item=state.cartItems.find((i)=> i.id===action.payload);
                if(item){
                    if(item.quantity > 1){
                        item.quantity-=1;
                    }else{
                        state.cartItems=state.cartItems.filter((i)=>i.id !== action.payload);
                    }

                }
            })
                    .addCase('deleteFromCart',(state,action)=>{
                        state.cartItems=state.cartItems.filter((i)=>i.id!==action.payload);

                    })

                    .addCase('calculateprice',(state)=>{
                        let sum=0;
                        state.cartItems.forEach((i)=> (sum=sum+i.price * i.quantity));
                        state.subtotal=sum;
                        state.shipping=state.subtotal > 1000 ? 0: 200;
                        state.tax=+(state.subtotal*0.18).toFixed();
                        state.total=state.subtotal + state.tax + state.shipping;
                    });
              
});
